import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {TranslationService} from './../utilities/TranslationUtilities';
import LexemePage, {getPage} from './page/LexemePage';
import {LanguageTypeahead} from './../dict-components/typeahead/LanguageTypeahead';
import {LanguageTypeAheadTypes, LexemeEditingLevel, LexemeUtilities} from './page/editor/LexemeHelper';
import {userService} from '../_redux/authentication/services/user.services';
import {performSearch} from '../search/lib/search';
import {Modal, Button, Col, Row, InputGroup, FormControl} from 'react-bootstrap';
import {EntryExternalDictionary} from "./page/editor/entry/EntryExternalDictionary";
import stylesSearchMenu from './../_css/dictionary/searchMenu.module.css';
import stylesLexemeTitle from "../_css/dictionary/lexemeParts/lexemeTitle.module.css";


export class TextTranslator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTextTranslator: true,
            text: '',
            translationText: '',
            langIn: null,
            langOut: null,
            status: 'default',
            selectedWord: null,
            showWordModal: false,
            wordResults: [],
            wordResultsLoading: false,
        };

        this._close = this._close.bind(this);
    }

    _close() {
        this.setState({showTextTranslator: false}, function () {
            this.emptyModalContainer();
        });
    }

    componentDidMount() {
        setTimeout(() => {
            ReactDOM.findDOMNode(this['formControl-id-translate-text']).focus();
        }, 200);

        var langOut = this.props.languages.find((language) => {
            return Dict.getGlobalProperty('FORMS_SEARCH_ACTIVE-' + language.id) === 'true';
        });
        var langIn = this.props.languages.find((language) => language !== langOut);

        // fallback alla logica originale se la property non è configurata
        if (!langOut) {
            this.props.languages.forEach((language) => {
                if (language.id === this.props.langIn)
                    langIn = language;
                else
                    langOut = language;
            });
        }

        this.setState({langIn, langOut});
    }

    emptyModalContainer() {
        setTimeout(function () {
            ReactDOM.unmountComponentAtNode(document.getElementById('dict-modal-text-translator-container'));
        }, 500);
    }

    _reverse() {
        const langIn = this.state.langOut;
        const langOut = this.state.langIn;

        this.setState({langIn, langOut});
    }

    _printTitle() {
        return this.state.langIn !== null ? Dict.t('TRANSLATE_TEXT') + ' <strong>' + this.state.langIn.label + '</strong> ▶ <strong>' + this.state.langOut.label + '</strong>' : '';
    }

    _translate() {
        this.setState({status: 'warning'});
        this.setState({translationText: ''});
        TranslationService.translateText(this.state.text, this.state.langIn.code, this.state.langOut.code).then((result) => {
            const translationText = result.target;
            this.setState({translationText, status: 'success'});
            setTimeout(() => {
                this.setState({status: 'default'})
            }, 1000);
        })
    }

    _onWordClick(word) {
        this.setState({selectedWord: word, showWordModal: true, wordResults: [], wordResultsLoading: true});
        Dict.call('/appService/findDeclinedForsmByWord/' + word + '/' + this.state.langOut.code + '/').then((result) => {
            const data = typeof result === 'string' ? JSON.parse(result) : result;
            this.setState({wordResults: data.result || [], wordResultsLoading: false});
        }).catch(() => {
            this.setState({wordResultsLoading: false});
        });
    }

    _renderTranslatedText(translationText) {
        if (!translationText) return null;
        return translationText.split(/(\s+)/).map((token, index) => {
            if (/^\s+$/.test(token)) {
                return <span key={index}>{token}</span>;
            }
            return (
                <span
                    key={index}
                    style={{cursor: 'pointer'}}
                    className={stylesSearchMenu['dict-translated-word']}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#e0e0e0';
                        e.currentTarget.style.borderRadius = '4px';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '';
                        e.currentTarget.style.borderRadius = '';
                    }}
                    onClick={() => this._onWordClick(token)}
                >
                    {token}
                </span>
            );
        });
    }

    render() {
        const translationText = this.state.translationText;

        return <React.Fragment>
            <Modal
                id={'dict-modal-text-translator'}
                show={this.state.showTextTranslator}
                dialogClassName={stylesSearchMenu['dict-modal-text-translator__dialog-modal']}
                onHide={() => {
                    this._close()
                }}
                restoreFocus>
                <Modal.Header closeButton>
                    <Modal.Title id='modal-translate-text__title'
                                 dangerouslySetInnerHTML={{__html: this._printTitle()}}>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsClass={stylesSearchMenu['dict-modal-text-translator__body']}>
                    <InputGroup className={stylesSearchMenu['dict-modal-text-translator__input-group']}>
                        <FormControl
                            autofocus={true}
                            id={'id-translate-text'}
                            componentClass="textarea"
                            className={stylesSearchMenu['dict-translate-text-textarea']}
                            aria-label="With textarea"
                            placeholder={''}
                            ref={(input) => {
                                this['formControl-id-translate-text'] = input;
                            }}
                            value={this.state.text}
                            onChange={(evt) => {
                                const text = evt.target.value;
                                this.setState({text});
                            }}
                            onKeyDown={() => {
                            }}
                        />
                    </InputGroup>
                    <Row className={stylesSearchMenu['dict-translate-text__row-buttons']}>
                        <Button onClick={() => {
                            this._reverse();
                        }}>inverti direzione</Button>
                        <Button onClick={() => {
                            const text = '';
                            const translationText = '';
                            this.setState({text, translationText})
                        }}>svuota</Button>
                        <Button bsStyle={this.state.status} onClick={() => {
                            this._translate()
                        }}>traduci</Button>
                    </Row>
                    <Row
                        className={stylesSearchMenu['dict-translate-text__row-result-container--' + (translationText.length > 0)]}>
                        <Row
                            className={stylesSearchMenu['dict-translate-text__row-label-result']}>{Dict.t('TRANSLATION')}:</Row>
                        <Row
                            className={stylesSearchMenu['dict-translate-text__row-result']}>
                            {this._renderTranslatedText(this.state.translationText)}
                        </Row>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal
                id={'dict-modal-word-detail'}
                show={this.state.showWordModal}
                onHide={() => this.setState({showWordModal: false})}
                bsSize="small">
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.selectedWord}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.wordResultsLoading
                        ? <p style={{textAlign: 'center'}}>...</p>
                        : (this.state.wordResults.length === 0 || (this.state.wordResults.length === 1 && this.state.wordResults[0].entryId === ''))
                            ? <p>{Dict.t('NO_RESULT_FOUND')}</p>
                            : <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                                {this.state.wordResults.map((item, idx) => (
                                    <li key={idx}
                                        style={{padding: '4px 0', borderBottom: '1px solid #eee', cursor: item.entryId ? 'pointer' : 'default'}}
                                        onMouseEnter={(e) => {
                                            if (item.entryId) {
                                                e.currentTarget.style.backgroundColor = '#e0e0e0';
                                                e.currentTarget.style.borderRadius = '4px';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '';
                                            e.currentTarget.style.borderRadius = '';
                                        }}
                                        onClick={() => {
                                            if (item.entryId) {
                                                this.setState({showWordModal: false});
                                                // LexemeUtilities.openLexemePage(item.entryId, item.entryId, true, userService.isLogged() ? LexemeEditingLevel.EDITABLE : LexemeEditingLevel.READ_ONLY, item.printDeclinedForm, null, '', this.state.langOut.id, this.state.langOut.code, undefined, null);
                                                performSearch({
                                                    forms: [{id: item.entryId, langId: this.state.langOut.id, className: 'Entry', label: item.entryForm}],
                                                    className: 'Entry',
                                                    langId: this.state.langOut.id,
                                                    nPage: 1,
                                                    type: 'STARTS_WITH'
                                                }, true, function () {
                                                    var ele = document.getElementById('dict-result-item-' + item.entryId);
                                                    if (ele) ele.click();
                                                });
                                            }
                                        }}>
                                        {item.printDeclinedForm}
                                    </li>
                                ))}
                            </ul>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => this.setState({showWordModal: false})}>Chiudi</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>;
    }
}